export default __webpack_public_path__ + "static/verso-5-710cd0d76f84ac1e7fcb273c3b0b4ace.jpg";